// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"a7d99afe","770":"5f60765b"}[chunkId] + ".chunk.js";
};